import type { Ref } from 'react';

import type { ITabButtonProps } from './model';

interface TabButtonProps extends ITabButtonProps {
  ref?: Ref<HTMLButtonElement>;
}

const TabButton = ({ isActive, label, onClick, tabId, ref }: TabButtonProps) => (
  <div className='flex-auto space-x-2 text-center !outline-hidden'>
    <button
      ref={ref}
      onClick={onClick}
      data-testid={tabId ? `tab-${tabId}` : undefined}
      {...(isActive && {
        style: {
          backgroundColor: 'var(--color-dark-grey-4)',
          color: 'var(--primary)',
        },
      })}
      className={`${
        isActive ? 'bg-info font-bold text-white !outline-hidden' : ''
      } hover:bg-c4 -mb-[1px] block w-full rounded-lg p-3.5 py-2 text-sm before:inline-block hover:text-white`}
    >
      {label}
    </button>
  </div>
);

export default TabButton;
